import { useEffect } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { ReminderImportWizard } from '../components';
import { getCompanyId } from '../utils';
import { useMessagingChannels } from '../../hooks/useMessagingChannels';
import { ChannelAvailabilityState } from '../../components/ChannelAvailabilityState';
import { usePermissions } from '@/common/hooks/usePermissions';
import { PERMISSIONS } from '@/common/config/permissions';
import { isMessagingChannelOpen } from '../../utils/messagingChannels';

export function ReminderImportPage() {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const requested =
    searchParams.get('channel') === 'email' ? 'email' : 'whatsapp';
  const companyId = getCompanyId();
  const channels = useMessagingChannels(companyId);
  const { can } = usePermissions();
  const open = channels.isReady && isMessagingChannelOpen(channels, requested);

  const only =
    channels.isReady && channels.email !== channels.whatsapp
      ? channels.email
        ? 'email'
        : channels.whatsapp
          ? 'whatsapp'
          : null
      : null;

  useEffect(() => {
    if (only && only !== requested) {
      navigate(`/reminders/import?channel=${only}`, { replace: true });
    }
  }, [only, requested, navigate]);

  if (!open) {
    return (
      <div className="p-6 max-w-md">
        <ChannelAvailabilityState
          status={channels}
          canOpenSettings={can(PERMISSIONS.SETTINGS.VIEW)}
        >
          <p className="text-sm font-medium text-[#1F2241]">
            That channel is not connected.
          </p>
        </ChannelAvailabilityState>
      </div>
    );
  }

  return (
    <ReminderImportWizard
      companyId={companyId}
      channel={requested}
      onClose={() => navigate('/reminders')}
    />
  );
}
